import { Helmet } from 'react-helmet';
import DonhangsanphamDetail
  from 'src/components/donhangsanpham-detail/DonhangsanphamDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import DonhangsanphamListToolbar from '../components/donhangsanpham-detail/DonhangsanphamToolbar';

const Donhangsanpham = () => (
  <>
    <Helmet>
      <title>Quản lý đơn hàng</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <DonhangsanphamListToolbar />
        <Box sx={{ pt: 3 }}>
          <DonhangsanphamDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Donhangsanpham;
